import { api, refreshSession } from "./client.ts";
import type { AuthTokens } from "@neuroxrehab/types";

export interface LoginPayload {
  email: string;
  password: string;
}

export async function login(payload: LoginPayload): Promise<AuthTokens> {
  const result = await api.post<AuthTokens>("/auth/login", payload);
  localStorage.setItem("accessToken", result.accessToken);
  localStorage.setItem("refreshToken", result.refreshToken);
  return result;
}

export async function logout(): Promise<void> {
  const refreshToken = localStorage.getItem("refreshToken");
  if (refreshToken) {
    await api.post("/auth/logout", { refreshToken }).catch(() => null);
  }
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}

export async function getMe() {
  return api.get<{ user: AuthTokens["user"] }>("/auth/me");
}

// Self-service password change. Unlike the admin-facing change-password call in
// AdminPage, this reissues the access token when the server clears
// mustChangePassword, since the current token still carries the stale claim
// until it expires or is refreshed.
export async function changeOwnPassword(userId: string, newPassword: string): Promise<void> {
  const result = await api.post<{ ok: boolean; accessToken?: string }>(
    `/users/${userId}/change-password`,
    { newPassword }
  );
  if (result.accessToken) localStorage.setItem("accessToken", result.accessToken);
}

export async function refreshAccessToken(): Promise<string | null> {
  return (await refreshSession()) ? localStorage.getItem("accessToken") : null;
}
